import { clientePedido } from '../../apiClient/index'

const moduloGestionNoticias = {
  namespaced: true,
  state: { 
    filtrosNoticia: undefined
  },
  actions: {
    
    getNoticiasPublicadas(context, payload) 
    { 
      return new Promise((resolve) => {
        clientePedido.get('/api/Noticia/FindPublicadas', { params: payload })
      .then(response => resolve(response.data))
      })
    },

    getNoticias(context, payload) {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Noticia/FindNoticias', {params: payload})
        // clientePedido.get(`/api/Noticia/Get?id=${id}`)
        .then(response => resolve(response.data))
      })
    },

    getNoticia(context, payload) {
      return new Promise((resolve)=> {

        clientePedido.get('/api/Noticia/Get', {params: payload})
        .then(response => resolve(response.data))
      })
    },

    uploadImagen(context, payload) {

      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/Noticia/UploadImagen?id=${payload.id}`, formData)
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },

    uploadImagenEmbebidaTemporal(context, payload) {
      let formData = new FormData()
      formData.append('imagen', payload.file)

      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/NoticiaImagen/UploadTemporal?idCarpetaTemporal=${payload.idCarpetaTemporal}`, formData)
          .then(
            response => { resolve(response.data) },
            error => { reject(error) }
          )
      })
    },

    anularNoticia(context, payload) {
      return new Promise(resolve =>{
        clientePedido.post(`/api/Noticia/AnularNoticia?id=${payload.id}`)
        .then(response => {
          var result = response.data
          resolve(result)
        })
      })
    },

    publicarNoticia(context, payload){

      return new Promise(resolve =>{
        clientePedido.post(`/api/Noticia/PublicarNoticia?noticiaId= ${payload.id}`)
        .then(response => {
          var result = response.data
          resolve(result)
        })
      })
    },


    saveNoticia(context, payload) {

      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Noticia/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    },

    setFiltrosNoticia(context, payload) {
      // guardo los filtros aplicados
      context.commit('setFiltrosNoticia', payload)
    }
  },
  mutations: {
    setFiltrosNoticia(state, payload) {
      state.filtrosNoticia = payload
    }
  }
}
export default moduloGestionNoticias